export const toHex = color => `000000${color.toString(16)}`.substr(-6);

export const showAdGroupColumn = inAdGroupLevel => !inAdGroupLevel;

export const showCampaignColumn = (inCampaignLevel, inAdGroupLevel) =>
  !inAdGroupLevel && !inCampaignLevel;

export const addCampaignColumn = (column, columns) => {
  columns.push(column({
    name: 'CampaignName',
    title: 'ColumnName_Campaign',
    sortable: true,
    type: 'string',
    helpId: 'pop_BA_Dimensions_Campaign',
  }));
};

export const addAdGroupColumn = (column, columns) => {
  columns.push(column({
    name: 'AdGroupName',
    title: 'ColumnName_AdGroup',
    sortable: true,
    type: 'string',
    helpId: 'pop_BA_Dimensions_AdGroup',
  }));
};
